<template>
  <!-- <v-list-tile>
        <v-list-tile-action>
            <v-icon :color="usedColor">
                {{usedIcon}}
            </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
            <v-lit-tile-title>
                {{label}}
            </v-lit-tile-title>
            <v-lit-tile-sub-title>
                {{value || '-'}}
            </v-lit-tile-sub-title>
        </v-list-tile-content>
        
  </v-list-tile>-->
  <div class="flex-container-space-between pb-3 pt-2">
    <div style="display: flex" class="vertical-center-container">
      <v-icon class="mr-2" :color="usedColor" v-if="!noIcon">{{usedIcon}}</v-icon>
      <div class="subheading grey--text text--darken-1">{{label}}</div>
    </div>

    <div class="subheading font-weight-bold">{{value || '-'}}</div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    color: String,
    label: String,
    value: String,
    override: Boolean,
    noIcon: Boolean
  },
  computed: {
    usedColor() {
      if (this.override || this.noIcon) {
        return this.color;
      }
      return this.$store.state.global.pages[this.label.toLowerCase()].color;
    },
    usedIcon() {
      if (this.override || this.noIcon) {
        return this.icon;
      }
      return this.$store.state.global.pages[this.label.toLowerCase()].icon;
    }
  }
};
</script>

<style>
</style>
